import gql from 'graphql-tag'

import { basicResponseHandler, arrayResponseHandler, fetchBase } from '../'
import { userAttrsFragment } from '../users'

const InvitesAPI = {
  createInvites: gql`
    mutation CreateInvites($invites: [InviteCreationInput!]!) {
      createInvites(invites: $invites) {
        ...userAttrs
      }
    }
    ${userAttrsFragment}
  `,
  deleteInvite({ apiEndpoint, apiToken }, { invite }) {
    const { organizationId, id } = invite
    return fetch(
      `${apiEndpoint}/organizations/${organizationId}/invites/${id}/delete`,
      {
        ...fetchBase({ apiToken }),
        method: 'POST',
      }
    ).then(basicResponseHandler)
  },
  resendInvite({ apiEndpoint, apiToken }, { invite }) {
    const { organizationId, id } = invite
    return fetch(
      `${apiEndpoint}/organizations/${organizationId}/invites/${id}/resend`,
      {
        ...fetchBase({ apiToken }),
        method: 'POST',
      }
    ).then(basicResponseHandler)
  },
  listInvites({ apiEndpoint, apiToken }, { organizationId }) {
    return fetch(`${apiEndpoint}/organizations/${organizationId}/invites`, {
      ...fetchBase({ apiToken }),
    }).then(arrayResponseHandler)
  },
}

export default InvitesAPI
